import {
    RULE_CATEGORY_DELETE_FAILURE,
    RULE_CATEGORY_DELETE_REQUEST,
    RULE_CATEGORY_DELETE_SUCCESS,
} from 'actions';

const initialState = {
    deleting: false,
    hasErrors: false,
};

export const ruleCategoryDeleteReducer = (state = initialState, action) => {
    const {type} = action;
    switch (type) {
        case RULE_CATEGORY_DELETE_SUCCESS: {
            return {
                ...state,
                deleting: false,
                hasErrors: false,
            }
        }

        case RULE_CATEGORY_DELETE_REQUEST: {return {
            ...initialState,
            deleting: true,
        }}

        case RULE_CATEGORY_DELETE_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
